module.exports = __webpack_public_path__ + "img/bg.87507bfd.png";